import { gql } from '@apollo/client';




export const CURRENT_USER = gql`
  query currentUser {
    currentUser {
    id
    title
    firstname
    lastname
    email
    phone
    gender
    status
    employers {
      activeTerm
      address
      campus {
        id
        name
      }
      email
      id
      logo
      name
      phone
      json{
        billingType
        termStart
        termEnd
        resumption
        closing
        resumptionEmployee
        closingEmployee
    }
      website
    }
    children {
      balance
      checkedIn
      dateOfBirth
      firstname
      gender
      id
      lastname
      middlename
      parentReplied
      parents {
        id
        title
        firstname
        lastname
        email
        phone
        gender
        status
        photo
      }
      photo
      room {
        id
        name
        real_class
      }
      status
    }
    photo
    dateOfBirth
  }
}
`;

export const GET_USERS = gql`
query GetUsers($input: userInput!, $schoolID: Int) {
  getUsers(input: $input, schoolID: $schoolID) {
    id
    title
    firstname
    email
    lastname
    phone
    gender
    status
    photo
    limitToClass
    schoolUserID
  }
}
`;


export const LOGIN = gql`
mutation response($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    accessToken
    refreshToken
  }
}
`;


export const PASSWORDLESS_LOGIN = gql`
mutation response($email: String!, $token: String!) {
  passwordlessLogin(email: $email, token: $token) {
    accessToken
    refreshToken
  }
}
`;


export const SEND_TOKEN = gql`
mutation sendLoginToken($email: String!) {
  sendLoginToken(email: $email)
}
`;



export const PASSWORDLESS_REGISTER = gql`
mutation response($input: RegisterInput) {
  passwordlessRegister(input: $input)
}
`;



export const FORGOT_PASSWORD = gql`
mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    message
    success
  }
}
`;


export const RESET_PASSWORD = gql`
mutation ResetPassword($email: String!, $token: String!, $password: String!) {
  resetPassword(email: $email, token: $token, password: $password) {
    success
    message
  }
}
`;

export const REGISTER = gql`
mutation response($input: RegisterInput) {
  register(input: $input) {
    success
    message
  }
}
`;




export const ACTIVATE_ACCOUNT = gql`
mutation Activate($token: String, $email: String) {
  activate(token: $token, email: $email)
}
`;

export const RESEND_ACTIVATION = gql`
mutation ResendActivation($email: String!) {
  resendActivation(email: $email)
}
`;




export const REMOVE_USER_FROM_SCHOOL = gql`
mutation RemoveUserFromSchool($userID: Int, $schoolID: Int, $role: StaffRoles!, $studentID: Int) {
  removeUserFromSchool(userID: $userID, schoolID: $schoolID, role: $role, , studentID: $studentID)
}
`;



export const UPDATE_PROFILE = gql`
mutation profile($input: UpdateUserInput) {
  updateProfile(input: $input) 
}
`;



export const RESET_USER_PASSWORD = gql`
mutation ResetUserPassword($schoolID: Int, $email: String!, $password: String!, $password2: String!) {
  resetUserPassword(schoolID: $schoolID, email: $email, password: $password, password2: $password2)
}
`;
